//no custom colors to define as this is comprised of other components that already have colors defined
export interface NewFaxFormColors {}
export const newFaxFormColors: NewFaxFormColors = {}
